import type { ContentTrackingListParams } from '@/marketing/models/contentTracking';

export const CONTENT_TRACKING_KEYS = {
  all: ['contentTracking'] as const,
  lists: () => [...CONTENT_TRACKING_KEYS.all, 'list'] as const,
  list: (campaignId: string, params: ContentTrackingListParams) =>
    [...CONTENT_TRACKING_KEYS.lists(), campaignId, params] as const,
};
